import { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  // Forcer le mode sombre par défaut
  const [theme, setTheme] = useState('dark');

  useEffect(() => {
    // Appliquer la classe au document - toujours dark pour le site public
    const root = document.documentElement;
    root.classList.add('dark');
    root.classList.remove('light');
    root.style.setProperty('--bg-primary', '#000000');
    root.style.setProperty('--bg-secondary', '#0D0D0D');
    root.style.setProperty('--text-primary', '#FFFFFF');
    root.style.setProperty('--text-secondary', '#888888');
  }, []);

  const toggleTheme = () => {
    // Désactivé - site toujours en mode sombre
  };

  const value = {
    theme: 'dark',
    setTheme: () => {},
    toggleTheme,
    isDark: true,
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}

export default ThemeContext;
